module.exports = __webpack_public_path__ + "static/media/calendar-icon.8914bdc2.svg";